import fetch from "auth/FetchInterceptor";

const ModuleService = {};

ModuleService.fetchModules = () =>
    fetch({
        url: "/module",
        method: "get",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
    });
ModuleService.postModule = (module) =>
    fetch({
        url: "/module",
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        data: module
    });

ModuleService.fetchModule = (id) =>
    fetch({
        url: `/module/${id}`,
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
    });

ModuleService.patchModule = ({ id, module }) =>
    fetch({
        url: `/module/${id}`,
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        data: module
    });
export default ModuleService;